module.exports = __webpack_public_path__ + "static/assets/6af339c52ea36eb6979b22f00a73dc7f.png";